module.exports = __webpack_public_path__ + "49e65970455f094a05937fe775fae656.svg";